"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNftSaleContract = void 0;
var react_1 = require("react");
var abi_1 = require("../abi");
function useNftSaleContract(config, web3, version) {
    if (version === void 0) { version = 'v1'; }
    return (0, react_1.useMemo)(function () {
        if (!web3 || !config.sale.address)
            return undefined;
        return new web3.eth.Contract(abi_1.CONTRACTS.nftSale[version].abi, config.sale.address);
    }, [web3, config.sale.address]);
}
exports.useNftSaleContract = useNftSaleContract;
